import { render, staticRenderFns } from "./change-password.vue?vue&type=template&id=4fdc39de&scoped=true"
import script from "./change-password.vue?vue&type=script&lang=js"
export * from "./change-password.vue?vue&type=script&lang=js"
import style0 from "./change-password.vue?vue&type=style&index=0&id=4fdc39de&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdc39de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fdc39de')) {
      api.createRecord('4fdc39de', component.options)
    } else {
      api.reload('4fdc39de', component.options)
    }
    module.hot.accept("./change-password.vue?vue&type=template&id=4fdc39de&scoped=true", function () {
      api.rerender('4fdc39de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/pages/change-password.vue"
export default component.exports